import { RoleEnum } from '@zeus/index'
import { useAuth } from '~/helpers/store/auth'
import AdminBilling from '~/pages/backoffice/admin/billing/AdminBilling'
import LearnerCountersTable from '~/pages/backoffice/admin/billing/LearnerCountersTable'

/**
 * Une URL, deux écrans (#45, #51) : l'opérateur plateforme observe toutes les
 * organisations, l'admin gère la facturation de la sienne — formule, montant,
 * historique et coordonnées. Le formateur n'y a pas accès : c'est une donnée
 * contractuelle, sans usage pour l'animation des sessions.
 */
function BillingPage() {
  const { payload } = useAuth()

  return payload?.role === RoleEnum.SuperAdmin
    ? <LearnerCountersTable />
    : <AdminBilling />
}

export default BillingPage
